(function () {
  'use strict';

  /* Prevent double initialization if script is loaded multiple times */
  if (window.__giftWrapPerItemInit) return;
  window.__giftWrapPerItemInit = true;

  var GIFT_WRAP_PRICE = 80;
  var STORAGE_KEY = 'saka_gift_wrap_items';
  var CURRENCY_SYMBOL = '₹';
  var saveTimer = null;
  var initTimer = null;
  var GIFT_WRAP_VARIANT_ID = window.GIFT_WRAP_VARIANT_ID; // Hardcoded from live store

  /* ── Helpers ── */
  function getSelections() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveSelections(selections) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selections));
  }

  /* ── Calculate gift wrap total from current cart ── */
  function calculateGiftWrapTotal() {
    var total = 0;
    var totalUnits = 0;

    document.querySelectorAll('[data-gift-wrap-checkbox]').forEach(function (cb) {
      var qty = parseInt(cb.dataset.giftWrapQty, 10) || 1;
      if (cb.checked) {
        total += qty * GIFT_WRAP_PRICE;
        totalUnits += qty;
      }
    });

    return { total: total, units: totalUnits };
  }

  /* ── Update UI ── */
  function updateGiftWrapDisplay() {
    var result = calculateGiftWrapTotal();
    
    document.querySelectorAll('[data-gift-wrap-total-row]').forEach(function (row) {
      if (result.total > 0) {
        row.style.display = 'flex';
        var label = row.querySelector('[data-gift-wrap-total-label]');
        var value = row.querySelector('[data-gift-wrap-total-value]');
        if (label) {
            label.textContent = 'Gift Wrap';
        }
        if (value) {
            value.innerHTML = Shopify.formatMoney(result.total * 100, window.money_format);
        }
      } else {
        row.style.display = 'none';
      }
    });
  }

  /* ── Server Sync ── */
  function saveToCartAttributes() {
    var result = calculateGiftWrapTotal();
    var wrappedItems = [];
    document.querySelectorAll('[data-gift-wrap-checkbox]:checked').forEach(function (cb) {
      var title = cb.dataset.giftWrapTitle || 'Item';
      var qty = parseInt(cb.dataset.giftWrapQty, 10) || 1;
      wrappedItems.push(title + ' (x' + qty + ')');
    });

    var payload = {
      attributes: {
        'Gift Wrap Total': result.total > 0 ? Shopify.formatMoney(result.total * 100, window.money_format) : '',
        'Gift Wrapped Items': wrappedItems.length > 0 ? wrappedItems.join(', ') : '',
        'Gift Wrap Units': result.units > 0 ? String(result.units) : ''
      },
      updates: {}
    };

    /* Link actually available Gift Wrap product to cart */
    if (GIFT_WRAP_VARIANT_ID) {
        payload.updates[GIFT_WRAP_VARIANT_ID] = result.units;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(r => r.json())
    .then(cart => {
      /* If sidebar is open or updateCart triggers are available, refresh it to show correct totals */
      if (window.halo && typeof window.halo.updateSidebarCart === 'function' && document.body.classList.contains('cart-sidebar-show')) {
        window.halo.updateSidebarCart(cart);
      }

        var nonGiftWrapSubtotal = 0;
        cart.items.forEach(item => {
            if (item.id !== GIFT_WRAP_VARIANT_ID) {
                nonGiftWrapSubtotal += item.original_price * item.quantity;
            }
        });

        var subtotalEl = document.querySelector('.cart-total-subtotal .cart-total-value .text');
        if (subtotalEl) {
            subtotalEl.innerHTML = Shopify.formatMoney(nonGiftWrapSubtotal, window.money_format);
        }

        var grandTotalValueEl = document.querySelector('[data-cart-total-value]');
        var grandTotalTextEl = document.querySelector('[data-cart-total-value] .text');

        if (grandTotalValueEl && grandTotalTextEl) {
            grandTotalValueEl.dataset.cartTotalValue = cart.total_price;
            grandTotalTextEl.innerHTML = Shopify.formatMoney(cart.total_price, window.money_format);
        }
    })
    .catch(function (error) {});
  }

  function debouncedSaveToCart() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveToCartAttributes, 1500);
  }

  function onCheckboxChange(event) {
    var cb = event.target;
    var itemKey = cb.dataset.giftWrapKey;
    var selections = getSelections();

    if (cb.checked) {
      selections[itemKey] = true;
    } else {
      delete selections[itemKey];
    }

    saveSelections(selections);
    updateGiftWrapDisplay();
    debouncedSaveToCart();
  }

  function initCheckboxes() {
    var selections = getSelections();
    var allCheckboxes = document.querySelectorAll('[data-gift-wrap-checkbox]');

    allCheckboxes.forEach(function (cb) {
      var itemKey = cb.dataset.giftWrapKey;
      cb.checked = !!selections[itemKey];
      cb.removeEventListener('change', onCheckboxChange);
      cb.addEventListener('change', onCheckboxChange);
    });

    /* Only clean up stale keys if there are checkboxes on the page */
    if (allCheckboxes.length > 0) {
      var currentKeys = {};
      allCheckboxes.forEach(function (cb) {
        currentKeys[cb.dataset.giftWrapKey] = true;
      });
      var changed = false;
      for (var key in selections) {
        if (!currentKeys[key]) {
          delete selections[key];
          changed = true;
        }
      }
      if (changed) {
        saveSelections(selections);
        debouncedSaveToCart();
      }
    }
    updateGiftWrapDisplay();
  }

  function debouncedInit() {
    clearTimeout(initTimer);
    initTimer = setTimeout(initCheckboxes, 200);
  }

  function init() {
    initCheckboxes();

    /* Make sure cart is synced on initial load */
    setTimeout(saveToCartAttributes, 2000);

    document.addEventListener('cart-update', debouncedInit);

    var sidebarWrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper');
    if (sidebarWrapper && typeof MutationObserver !== 'undefined') {
      new MutationObserver(debouncedInit).observe(sidebarWrapper, { childList: true, subtree: true });
    }

    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class' && document.body.classList.contains('cart-sidebar-show')) {
          debouncedInit();
        }
      });
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();